import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAiqfomeComponent } from './simple-icons-aiqfome.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAiqfomeComponent ],
    exports:      [ SimpleIconsAiqfomeComponent ],
    bootstrap:    []
})
export class SimpleIconsAiqfomeModule {}
